import PropTypes from 'prop-types';

const VARIANT_CLASSES = {
  gold: 'bg-gold-500 text-white',
  primary: 'bg-primary-700 text-white',
  neutral: 'bg-neutral-100 text-neutral-700',
};

const Badge = ({ children, variant = 'gold', className = '' }) => (
  <span
    className={`inline-flex items-center whitespace-nowrap rounded-pill px-3 py-1 text-xs font-semibold ${VARIANT_CLASSES[variant] || VARIANT_CLASSES.gold} ${className}`}
  >
    {children}
  </span>
);

Badge.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['gold', 'primary', 'neutral']),
  className: PropTypes.string,
};

export default Badge;
